import { Box, Card, Avatar, Chip } from '@mui/material';
import { styled } from '@mui/system';
import { fadeIn, pulse } from '../animations';

export const MessagesContainer = styled(Box)(() => ({
    flex: 1,
    overflowY: 'auto',
    backgroundColor: '#ffffff',
    padding: '20px 0',
    '&::-webkit-scrollbar': {
        width: '8px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
        borderRadius: '4px',
        '&:hover': {
            background: '#a1a1a1',
        }
    },
}));

export const MessageBubble = styled(Box)(() => ({
    maxWidth: '700px',
    margin: '0 auto',
    marginBottom: '24px',
    padding: '0 20px',
    animation: `${fadeIn} 0.3s ease-out`,
    position: 'relative',
    '&:hover .message-actions': {
        opacity: 1,
    }
}));

export const MessageHeader = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '8px',
}));

export const MessageContent = styled(Box)(({sender, theme}) => ({
    backgroundColor: sender === 'user' ? '#5865f2' : '#f8f9fa',
    color: sender === 'user' ? '#ffffff' : theme.palette.text.primary,
    padding: '16px 20px',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    position: 'relative',
    border: sender === 'user' ? 'none' : '1px solid #e9ecef',
    '&::before': sender === 'user' ? {
        content: '""',
        position: 'absolute',
        left: '-8px',
        top: '20px',
        width: 0,
        height: 0,
        borderTop: '8px solid transparent',
        borderBottom: '8px solid transparent',
        borderRight: '8px solid #5865f2',
    } : {},
    '&::after': sender === 'ai' ? {
        content: '""',
        position: 'absolute',
        right: '-8px',
        top: '20px',
        width: 0,
        height: 0,
        borderTop: '8px solid transparent',
        borderBottom: '8px solid transparent',
        borderLeft: '8px solid #f8f9fa',
    } : {},
}));

export const MessageActions = styled(Box)(() => ({
    display: 'flex',
    gap: '4px',
    marginTop: '8px',
    opacity: 0,
    transition: 'opacity 0.2s ease',
}));

export const ActionChip = styled(Chip)(({theme}) => ({
    height: '28px',
    fontSize: '0.75rem',
    backgroundColor: 'rgba(255,255,255,0.1)',
    color: theme.palette.text.secondary,
    border: '1px solid #e9ecef',
    '&:hover': {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.primary,
    }
}));

export const ModernAvatar = styled(Avatar)(({theme, variant}) => ({
    width: 40,
    height: 40,
    backgroundColor: variant === 'user' ? theme.palette.primary.main : theme.palette.secondary.main,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    border: '3px solid #ffffff',
}));

export const WelcomeCard = styled(Card)(() => ({
    maxWidth: '600px',
    margin: '40px auto',
    padding: '40px 30px',
    textAlign: 'center',
    backgroundColor: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    border: '1px solid #e9ecef',
    borderRadius: '20px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
}));

export const WelcomeIcon = styled(Box)(({theme}) => ({
    width: '80px',
    height: '80px',
    margin: '0 auto 24px',
    background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    borderRadius: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 24px rgba(88, 101, 242, 0.3)',
}));

export const TypingIndicator = styled(Box)(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '12px 16px',
    '& .typing-dot': {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        animation: `${pulse} 1.5s infinite`,
        '&:nth-child(2)': {
            animationDelay: '0.2s',
        },
        '&:nth-child(3)': {
            animationDelay: '0.4s',
        },
    }
}));
